export default __webpack_public_path__ + "static/media/fifth.b4c94377.jpg";